'use client'
import DataMgr from "@/Fwk/DataMgr"
import {LoginType} from "@/app/userSlice";

const TokenKey = 'Admin-Token'
const UserIdKey = 'Admin-UserId'
const LoginTypeKey = 'Admin-LoginType'
const RewardTypeKey = 'Admin-RewardType'
const TokenExpireTime = 'Admin-TokenExpireTime'
const LoggedOutKey = 'Admin-LoggedOut'
const UuidChangeKey = 'Admin-UuidChange'

//用户token
export function getToken() {
    return DataMgr.getStorage(TokenKey) || ''
    // return '55fd92d87e2c0e3cec689ce75bbaf8d6'
}
export function setToken(token: string) {
    return DataMgr.setStorage(TokenKey, token)
}
export function removeToken() {
    return DataMgr.clear(TokenKey)
}

// 用户ID
export function getUserId() {
    return Number(DataMgr.getStorage(UserIdKey)) || 0;
}
export function setUserId(userId: any) {
    return DataMgr.setStorage(UserIdKey, userId)
}
export function removeUserId() {
    return DataMgr.clear(UserIdKey)
}

// 登陆模式
export function getLoginType() {
    return Number(DataMgr.getStorage(LoginTypeKey))
}

//是否帐号登陆模式
export function isLoginAccount() {
    return getLoginType() == LoginType.normal;
}


export function setLoginType(type: any) {
    return DataMgr.setStorage(LoginTypeKey, type)
}
export function removeLoginType() {
    return DataMgr.clear(LoginTypeKey)
}

// 奖励模式
export function setLocalRewardType(type: any) {
    return DataMgr.setStorage(RewardTypeKey, type)
}
export function getLocalRewardType() {
    return Number(DataMgr.getStorage(RewardTypeKey))
}
export function removeLocalRewardType() {
    return DataMgr.clear(RewardTypeKey)
}

// token失效时间
export function setTokenExpireTime(time: number) {
    return DataMgr.setStorage(TokenExpireTime, `${time}`);
}
export function getTokenExpireTime() {
    return Number(DataMgr.getStorage(TokenExpireTime)) || 0;
}
export function removeTokenExpireTime() {
    return DataMgr.clear(TokenExpireTime)
}

export function removeAuthInfo() {
    removeToken();
    removeUserId();
    removeLoginType();
    // removeLocalRewardType();
    removeTokenExpireTime();
}

// 用户登出
export function setLocalLogout() {
    return DataMgr.setStorage(LoggedOutKey, 'true');
}
export function getLocalLogout() {
    return DataMgr.getStorage(LoggedOutKey) === 'true';
}
export function removeLocalLogout() {
    return DataMgr.clear(LoggedOutKey);
}

// uuid
export function setUuidChange(uuidChange: boolean) {
    return localStorage.setItem(UuidChangeKey, `${uuidChange}`);
}
export function getUuidChange() {
    return localStorage.getItem(UuidChangeKey) == "true";
}